import { getOptionValue } from "@helpers/options";
import React, { useState } from "react";
import { Icon, Input } from "semantic-ui-react";

const TextInput = (props) => {
  const { option, onChange, error, tabIndex } = props;
  const [masked, setMasked] = useState(option.isPassword || false);
  return (
    <Input
      fluid
      icon={
        option.isPassword && (
          <Icon name="eye" link onClick={() => setMasked(!masked)} />
        )
      }
      value={getOptionValue(option)}
      onChange={(event, { value }) => onChange(value)}
      readOnly={!option.isEditable}
      type={masked ? "password" : "text"}
      autoFocus={option.setFocus}
      tabIndex={tabIndex}
      error={error}
      placeholder={option.placeHolder}
      onBlur={props.onBlur}
    />
  );
};

export default TextInput;
